/**
 * Order Investigation Adapter
 *
 * Fetches the pre-built investigation case from the backend:
 *   GET /projection/order/:orderId/investigation-case
 *
 * All milestone resolution, GPS sampling, and evidence gathering
 * is handled server-side by the OrderInvestigationCaseBuilder.
 */

import { API_ENDPOINTS } from '../config/api';
import { authenticatedFetch } from '../utils/authenticatedFetch';
import type { OrderInvestigationCase } from '../types/orderInvestigation';

/**
 * Fetch the investigation case for an order from the backend.
 *
 * @param orderId  Truth-layer entity ID (ULID) for the order
 */
export async function buildInvestigationCase(
  orderId: string,
  _displayName?: string,
): Promise<OrderInvestigationCase> {
  const url = API_ENDPOINTS.orderProjection.investigationCase(orderId);
  const res = await authenticatedFetch(url);

  if (res.status === 404) {
    throw new Error('Order not found');
  }
  if (!res.ok) {
    throw new Error(`Investigation case fetch failed: ${res.status}`);
  }

  return res.json();
}
